<template>
	<section :style="height">
		<transition name="fade-transform" mode="out-in">
			<router-view/>
		</transition>
	</section>
</template>
<script>
export default {
	data() {
		return {
			height: ''
		}
	},
	computed: {
		key() {
		},
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods: {
		isSmartPhone() {
			// UserAgentからのスマホ判定
			if (navigator.userAgent.match(/pad|pod|iPod|iPad|iPhone|Android|Android.+Mobile/)) {
				return true;
			} else {
				return false;
			}
		},
		isSmartPhone2() {
			// デバイス幅が640px以下の場合にスマホと判定する
			if (
				window.matchMedia &&
				window.matchMedia("(max-device-width: 640px)").matches
			) {
				return true;
			} else {
				return false;
			}
		},
		init() {
			if(this.isSmartPhone() || this.isSmartPhone2()) {
				this.height = 'min-height:' + (window.innerHeight - 97) + 'px;'
			}else {
				this.height = 'min-height:' + (window.innerHeight - 137) + 'px;'
			}
		}
	}
}
</script>
<style lang="scss" scoped>
section{
	background-color: #F5F7F9;
}
</style>
